<template>
	<v-card>
		<v-card-title>
			<v-spacer />
			<v-spacer />
			<v-text-field
				v-model="lookingFor"
				append-icon="mdi-magnify"
				label="חיפוש"
				single-line
				hide-details
			/>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="coupons"
			:loading="loading"
			class="elevation-1"
			:search="lookingFor"
			:items-per-page="20"
			:options.sync="options"
			:sort-by.sync="options.sortBy"
			:sort-desc.sync="options.sortDesc"
			:footer-props="{
        												itemsPerPageOptions: [10,20,50,-1]
      									}"
		>
			<v-progress-linear
				slot="progress"
				color="blue"
				indeterminate
			/>
			<template #item.project="{item}">
				<template v-if="item.project">
					project.subject
				</template>
				<template v-else>
					כללי
				</template>
			</template>
			<template #item.expire_at="{item}">
				<date-span
					v-if="item.expire_at"
					:date="item.expire_at"
				/>
			</template>
			<template #item.type="{item}">
				<template v-if="item.type === 'fixed' ">
					מחיר קבוע
				</template>
				<template v-else>
					אחוזים
				</template>
			</template>
			<template #item.is_one_time="{item}">
				<template v-if="item.is_one_time === 1 ">
					כן
				</template>
				<template v-else>
					לא
				</template>
			</template>

			<template #item.action="{item}">
				<action-td
					:item="item"
					module="coupon"
					@edit="onEdit"
				/>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import ActionTd from "../../components/AcationTd";
import FilterAble from "../../mixins/FilterAble";
import { types } from "src/store/modules/Coupon.module";
import DateSpan from "@/components/DateSpan";

export default {
	name: "CouponsTable",
	components: {
		DateSpan,
		ActionTd,
	},
	mixins: [new FilterAble(types)],
	props: [],
	data () {
		return {
			loading: false,
			headers: [
				{ text: "קוד", value: "code" },
				{ text: "פרויקט", value: "project.subject" },
				{ text: "סוג", value: "type" },
				{ text: "הנחה", value: "discount" },
				{ text: "חד פעמי", value: "is_one_time" },
				{ text: "תאריך תפוגה", value: "expire_at" },
				{ text: "תאריך יצירה", value: "created_at" },
				{ text: "פעולות", value: "action" },
			],
			lookingFor: null,
			showDialog: false,
			options: {
				sortBy: ['created_at'],  // מיון לפי עמודת createdAt
				sortDesc: [true],       // מיון בסדר יורד (מהחדש לישן)
				itemsPerPage: 5
			}
		};
	},
	computed: {
		coupons () {
			return this.$store.state.CouponModule.coupons;
		},
	},
	methods: {
		onEdit (coupon) {
			this.$emit("edit", coupon);
		},
	},
};
</script>
